<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Comisiones
          </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_01_COM_GRAL</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Reporte general de comisiones</b-col>
      </b-row>
      <b-tabs content-class="mt-3">
        <b-tab title="BIP" active>
          <ReporteComisionesGeneral></ReporteComisionesGeneral>
        </b-tab>
        <b-tab title="BRM">
          <ReporteComisionesBrmGeneral></ReporteComisionesBrmGeneral>
        </b-tab>
        <b-tab title="Layout" v-if="this.$localStorageService.can('RC_01_comis_layout')">
          <Layout></Layout>
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import ReporteComisionesGeneral from "./ReporteComisionesGeneral";
import Header from "../../components/Header";
import ReporteComisionesBrmGeneral from "./ReporteComisionesBrmGeneral";
import Layout from "./Layout";
export default {
  name: "Comisiones",
  components: {ReporteComisionesBrmGeneral, Header, ReporteComisionesGeneral, Layout},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>